import {Trans} from '@lingui/macro';
import React from 'react';

import {CollapsedItemKeyPrefixesEnum} from '../../../models/api/localPreferencesModel';
import {useSettingsInfoBox, UseSettingsInfoBoxProps} from '../../helpers/settingsInfoBox';

/*
 * Consts.
 */

const settingsInfoBoxProps: UseSettingsInfoBoxProps = {
  settingsExpandedKey: CollapsedItemKeyPrefixesEnum.SETTINGS_AUTOLINKERS,
  title: <Trans id="settings-autolinkers-infobox-title">Autolinkers</Trans>,
  body: (
    <Trans id="settings-autolinkers-infobox-body">
      <p>
        An <strong>autolinker</strong> allows you to automatically create links when references to external
        objects are found in a comment.
      </p>
      <p>You can auto-link external resources like quotes, order forms, invoices or tickets.</p>
      <p>You can also extract references from messages using rules.</p>
    </Trans>
  ),
};

/*
 * Hook.
 */

export function useAutolinkersInfoBox() {
  return useSettingsInfoBox(settingsInfoBoxProps);
}
